import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/api/v1/trackings',
    method: 'get',
    params
  })
}

export function show($id) {
  return request({
    url: `/api/v1/trackings/${id}`,
    method: 'get',
    params
  })
}

export function create(data) {
  return request({
    url: '/api/v1/trackings',
    method: 'post',
    data
  })
}

export function update(id, data) {
  return request({
    url: `/api/v1/trackings/${id}`,
    method: 'put',
    // config: { headers: { 'Content-Type': 'multipart/form-data' }},
    data
  })
}

export function destroy(id) {
  return request({
    url: `/api/v1/trackings/${id}`,
    method: 'delete'
  })
}

export function weekly(params) {
  return request({
    url: '/api/v1/trackings/weekly',
    method: 'get',
    params
  })
}

export function monthly(params) {
  return request({
    url: '/api/v1/trackings/monthly',
    method: 'get',
    params
  })
}

export function yearly(params) {
  return request({
    url: '/api/v1/trackings/yearly',
    method: 'get',
    params
  })
}

export function unknown(params) {
  return request({
    url: '/api/v1/trackings/unknown',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/tracking.js